import { NewFilter } from '@/types/NewFilter';

export const filters: NewFilter[] = [
	{
		key: 'activity',
		name: 'Atividade',
		isMulti: true,
		isDisabled: () => false,
	},
	{
		key: 'pole',
		name: 'Polo da Atividade',
		isMulti: true,
		isDisabled: () => false,
	},
	{
		key: 'board',
		name: 'Diretoria',
		isMulti: true,
		isDisabled: () => false,
	},
	{
		key: 'management',
		name: 'Gerência',
		isMulti: true,
		isDisabled: () => false,
	},
	{
		key: 'coordination',
		name: 'Coordenação',
		isMulti: true,
		isDisabled: () => false,
	},
	{
		key: 'jobTitle',
		name: 'Cargo',
		isMulti: true,
		isDisabled: () => false,
	},
	{
		key: 'workstation',
		name: 'Local de Trabalho',
		isMulti: true,
		isDisabled: () => false,
	},
	{
		key: 'conditionTraining',
		name: 'Treinamento da Condição',
		isMulti: true,
		isDisabled: () => false,
	},
	{
		key: 'conditionStatus',
		name: 'Status da Condição',
		isMulti: true,
		isDisabled: () => false,
	},
];
